module.exports = function fail(message) {
  throw new TypeError('[tcomb] ' + message);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/fail.js
 ** module id = 1037
 ** module chunks = 0
 **/